function login () {
	const elId = '#app-login';
	const elClass = '.js-vue-login';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const app = new Vue({
		el: elId,
		data: {
			twoFactor: {
				show: false,
				pin: null
			},
			login: {
				username: null,
				password: null
			},
			error: null
		},
		created: function () { },
		mounted: function () {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			doLogin: function () {
				window.validateAll();
				if (isLoading() || !window.isInputValid()) {
					return;
				}
				toggleLoader(true);
				sessionStorage.clear();
				const self = this;
				const tryLoginWithUser = self.login;
				const returnRegex = /ReturnUrl=([^&]*)/gi;
				const result = returnRegex.exec(document.location.href);
				tryLoginWithUser.returnUrl = result != null && result.length > 1 ? unescape(result[1]) : null;
				POST('/auth/login', tryLoginWithUser)
					.then(xhr => {
						self.error = null;
						const response = JSON.parse(xhr.responseText);
						console.log('loginresponse'.response);
						if (response.status) {
							document.location.href = response.url;
						} else {
							if (response.twoFactor) {
								self.twoFactor.show = true;
							}
							else {
								self.error = 'User or combination does not exist.';
							}
							toggleLoader(false);
						}
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : 'Connection timeout, please try again later';
						toggleLoader(false);
					});
			},
			doTwoFactor: function () {
				var self = this;
				toggleLoader(true);
				const tryLoginWithUser = self.login;
				const returnRegex = /ReturnUrl=([^&]*)/gi;
				const result = returnRegex.exec(document.location.href);
				tryLoginWithUser.returnUrl = result != null && result.length > 1 ? unescape(result[1]) : null;
				tryLoginWithUser.pin = this.twoFactor.pin;
				POST('/auth/checktwofactor', tryLoginWithUser).then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					console.log('loginresponse'.response);
					if (response.status) {
						document.location.href = response.url;
					} else {
						self.error = 'Failed to validate.';
						toggleLoader(false);
					}

				})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : 'Connection timeout, please try again later';
						toggleLoader(false);
					});

			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
login();
